import React from 'react'
import { Button } from 'react-bootstrap'
import moment from 'moment'
import Decrypt from '../../utils/decrypt'
import { Translate } from 'components/Translate'

const TransError = Translate('errors')

const typeMessages = {
    ERROR: 'error'
}

const traderMessage = ({username, message, create_at, _id, hash, showName, showHour}) => (
    <div key={_id} className="message-box-holder">
        {showName && <div className="message-sender">{username}</div>}
        <div className={`message-box message-partner ${!showName ? '' : ''}`} >
            {Decrypt(message, hash)}
        </div>
        {showHour && <p className="message-date-user">{moment(create_at).format('HH:mm:ss')}</p>}
    </div>
)
const myMessage = ({message, create_at, _id, hash, showName, showHour, me }) => (
    <div key={_id} className="message-box-holder">
        {showHour && <p className="message-date">{moment(create_at).format('HH:mm:ss')}</p>}
        <div className={`message-box ${!showName ? 'grouped' : ''}`}>{Decrypt(message, hash)}</div>
        {showName && <div className="message-sender own">{me}</div>}
    </div>
)

const FileBox = ({title, refId, classes, downloadFile}) => (
    <div className={classes}>
        <Button className="file-modal" onClick={() => downloadFile(refId)}>
            <i className="icon-file"></i>
        </Button>
        <p>{title}</p>
    </div>
) 

const renderOwnFile = ({ title, fileName, me, refId, classes, create_at, index, downloadFile}) => {
    return (
        <div key={index} className="message-box-holder">
            <p className="message-date">{moment(create_at).format('HH:mm:ss')}</p>
            <FileBox
                title={title || fileName}
                refId={refId}
                classes={classes}
                downloadFile={downloadFile} 
            />
            <div className="message-sender own">{me}</div>
        </div>
    )
}
const renderUserFile = ({title, fileName, username, refId, classes, create_at, index, downloadFile}) => {
    return (
        <div key={index} className="message-box-holder">
            <div className="message-sender">{username}</div>
            <FileBox
                title={title || fileName}
                refId={refId}
                classes={classes}
                downloadFile={downloadFile} 
            />
            <p className="message-date-user">{moment(create_at).format('HH:mm:ss')}</p>
        </div>
    )
}

export const SystemMessage = ({ children }) => (
    <div className="message-box-error">
        <div className="message">{children}</div>
    </div>
)

export const errorMessage = ({message, index}) => (
    <div key={index} className="message-box-error">
        <div className="message"><TransError tag={message} /></div>
    </div>
)
export const renderFile = ({ me, m, index, userId, downloadFile }) => {
    const { title, fileName, userId: uuid, refId, create_at, username } = m
    const ownFile = userId === uuid
    const classes = ownFile ? 'message-box flex' : 'message-box flex message-partner'
    if(ownFile)
        return renderOwnFile({ me, title, fileName, username, refId, classes, create_at, index, downloadFile })
    return renderUserFile({ title, fileName, username, refId, classes, create_at, index, downloadFile })
}
export const renderMessage = ({ me, m, index, userId, hash, showName, showHour }) => {
    const { _id, username, create_at, message, userId: uuid, type } = m
    if (type === typeMessages.ERROR)
        return errorMessage({message, index})
    else if (userId === uuid)
        return myMessage({ me, message, create_at, _id, hash, showName, showHour })
    else
        return traderMessage({ username, message, create_at, _id, hash, showName, showHour })
}



// WEBPACK FOOTER //
// ./src/components/ChatWindow/renders.js